export const SW_UPDATE_EVENT = 'sw-update-available';
const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;
let waitingWorker = null;
export function skipWaitingSW() {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
}
export function isUpdateAvailable() {
    return waitingWorker !== null;
}
function notifyUpdateAvailable(worker) {
    waitingWorker = worker;
    window.dispatchEvent(new CustomEvent(SW_UPDATE_EVENT));
}
export default function installServiceWorker() {
    if (__DEV__ || !('serviceWorker' in navigator))
        return;
    window.addEventListener('load', async () => {
        try {
            const registration = await navigator.serviceWorker.register('/service-worker.js');
            console.log('ServiceWorker registration successful with scope:', registration.scope);
            if (registration.waiting) {
                notifyUpdateAvailable(registration.waiting);
            }
            registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing;
                if (!newWorker)
                    return;
                newWorker.addEventListener('statechange', () => {
                    if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                        notifyUpdateAvailable(newWorker);
                    }
                });
            });
            setInterval(() => {
                registration.update();
            }, UPDATE_CHECK_INTERVAL_MS);
        }
        catch (err) {
            console.error('ServiceWorker registration failed:', err);
        }
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (refreshing)
                return;
            refreshing = true;
            window.location.reload();
        });
    });
}
